// extracted by css-extract-rspack-plugin
export default {"sortIcon":"SavedViewOptionsMenu-module__sortIcon__YEACU","status":"SavedViewOptionsMenu-module__status__pAn3U"};